import { render } from "./PriceCalendar.vue?vue&type=template&id=0c299e6a"
import script from "./PriceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PriceCalendar.vue?vue&type=style&index=0&id=0c299e6a&lang=css"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/PriceCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c299e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c299e6a', __exports__)) {
    api.reload('0c299e6a', __exports__)
  }
  
  module.hot.accept("./PriceCalendar.vue?vue&type=template&id=0c299e6a", () => {
    api.rerender('0c299e6a', render)
  })

}


export default __exports__